import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';

export const walletUserStopCancel = http.patch(
  createMockEndpoint('/wallet_user/:id/stop_cancel'),
  async () => {
    await delay(500);
    return HttpResponse.json(null, { status: 200 });
  },
);
